import styles from 'css/src/components/common/ui/Select/CustomClearIndicator.module.scss';

import React from 'react';
import type { ClearIndicatorProps } from 'react-select';

const CustomClearIndicator = (props: ClearIndicatorProps<any, any, any>) => {
    const {
        children = (
            <>
                <span
                    translate="no"
                    className={`material-symbols-outlined ${styles['clear-all-selected']}`}
                >
                    cancel
                </span>
            </>
        ),
        innerProps: { ref, ...restInnerProps },
    } = props;
    return (
        <div {...restInnerProps} ref={ref}>
            <div>{children}</div>
        </div>
    );
};

export default CustomClearIndicator;
